import CategoriesTable from './CategoriesTable';

export default CategoriesTable;
